import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { AiRenderingPage } from '@/pages/renderings';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/image-rendering')({
  component: AiRenderingPage,
  validateSearch: zodValidator(
    z.object({
      imageId: z.string().optional(),
      mediaId: z.string().optional(),
      estateId: z.string().optional(),
      projectId: z.string().optional(),
      source: z.enum(['editor']).optional(),
      tool: z.enum(['ai-rendering', 'magic-edit']).optional(),
    })
  ),
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="ai-rendering" /> },
});
